import { BulletPointTextarea, Form } from "@/base";
import { Card, CardBody, cn } from "@heroui/react";
import { joiResolver } from "@hookform/resolvers/joi";
import {
    type ApplicantShared,
    type ApplicantUpdateDto,
    ApplicantValidationSchemas,
    validationOptions,
} from "@sr-partner-portal/common";
import { useForm } from "react-hook-form";

export type ApplicantUpdateFormParameters = ConstructorParameters<
    typeof ApplicantUpdateDto
>[0];

interface ApplicantInternalNotesProps {
    applicant: ApplicantShared;
    isViewOnly: boolean;
}

const ApplicantInternalNotes = ({
    applicant,
    isViewOnly,
}: ApplicantInternalNotesProps) => {
    const formController = useForm<ApplicantUpdateFormParameters>({
        resolver: joiResolver(
            ApplicantValidationSchemas.update.full.form,
            validationOptions,
        ),
        defaultValues: {
            profile: applicant?.profile || "",
        },
    });

    if (!applicant?.profile) {
        return null;
    }

    return (
        <Card
            shadow="none"
            classNames={{
                base: "border border-default-200",
            }}
        >
            <CardBody>
                <Form controller={formController}>
                    <div className="flex h-full flex-col gap-2">
                        <div>Stahlhart Notizen</div>
                        <BulletPointTextarea
                            fieldName="profile"
                            label="Stahlhart Notizen"
                            isDisabled={true}
                            hideLabel={true}
                            className={cn("h-full min-h-52", isViewOnly && "opacity-70")}
                            wrapperClassName="h-full"
                        />
                    </div>
                </Form>
            </CardBody>
        </Card>
    );
};

export { ApplicantInternalNotes };
